import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import test from "../images/projects/teste.png";
import savoinimauxImgPreview from "../images/projects/savoinimaux-preview.png";
import pacteImgPreview from "../images/projects/pacte-preview.png"

export default function ProjectsPage() {
  const projects = [
    {
      number: "01",
      title: "PACTE",
      category: "Application mobile",
      year: "2025",
      previewImage: pacteImgPreview || null,
      description:
        "Une application mobile pensée pour dynamiser le commerce local — fidélité digitale, messagerie, actualités et événements dans un seul écosystème.",
      details: ["iOS & Android", "Fidélité digitale", "Messagerie intégrée", "Notifications"],
      link: "/projects/pacte",
    },
    {
      number: "02",
      title: "Savoinimaux",
      category: "Site web",
      year: "2025",
      previewImage: savoinimauxImgPreview || null,
      description:
        "Refonte complète de la présence digitale d'une association — image modernisée, structure clarifiée, crédibilité renforcée.",
      details: ["Refonte visuelle", "UX repensée", "Identité retravaillée", "Site moderne"],
      link: "/projects/savoinimaux",
    },
    {
      number: "03",
      title: "AJ Construction",
      category: "Présence digitale",
      year: "2026",
      previewImage: test || null,
      description:
        "Visibilité locale, image professionnelle et cohérence globale pour un artisan du bâtiment — stratégie de contenu et optimisation digitale.",
      details: ["Visibilité locale", "Image pro", "Stratégie contenu", "SEO local"],
      link: "/projects/aj-construction",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-black font-asap selection:bg-black selection:text-white">
      <NavBar />

      <div className="max-w-5xl mx-auto px-6 md:px-10">

        {/* HERO */}
        <section className="pt-20 pb-16">
          <h1 className="text-[3.2rem] md:text-[5.5rem] font-bold leading-[1] tracking-[-0.04em] mb-5">
            Nos projets
          </h1>
          <p className="text-black/45 text-[16px] md:text-[19px] leading-relaxed max-w-lg">
            Applications mobiles, sites web et accompagnements digitaux conçus avec une attention particulière à l'image et à l'expérience.
          </p>
        </section>

        {/* PROJECTS */}
        <section className="pb-28 space-y-32">
          {projects.map((project, i) => {
            const isEven = i % 2 === 1;
            return (
              <div key={project.title}>
                {/* TOP ROW: number + meta */}
                <div className="flex items-center justify-between mb-8 pb-5 border-b border-black/8">
                  <div className="flex items-baseline gap-5">
                    <span className="text-[11px] text-black/30 tabular-nums">{project.number}</span>
                    <span className="text-[12px] uppercase tracking-[0.16em] text-black/40 font-medium">
                      {project.category}
                    </span>
                  </div>
                  <span className="text-[13px] text-black/30">{project.year}</span>
                </div>

                {/* CONTENT: image + text, alternating sides */}
                <div className={`grid md:grid-cols-2 gap-10 md:gap-16 items-center ${isEven ? "md:[direction:rtl]" : ""}`}>

                  {/* IMAGE */}
                  <div className={isEven ? "[direction:ltr]" : ""}>
                    <div className="rounded-[20px] overflow-hidden bg-[#f5f5f5]">
                      {project.previewImage ? (
                        <img
                          src={project.previewImage}
                          alt={project.title}
                          className="w-full h-[300px] md:h-[400px] object-cover"
                          loading="lazy"
                        />
                      ) : (
                        <div className="w-full h-[300px] md:h-[400px] bg-[#ebebeb]" />
                      )}
                    </div>
                  </div>

                  {/* TEXT */}
                  <div className={`flex flex-col justify-center ${isEven ? "[direction:ltr]" : ""}`}>
                    <h2 className="text-[2.4rem] md:text-[3.2rem] font-bold leading-[1] tracking-[-0.04em] mb-5">
                      {project.title}
                    </h2>

                    <p className="text-black/55 text-[15px] md:text-[17px] leading-relaxed mb-7 max-w-sm">
                      {project.description}
                    </p>

                    {/* DETAILS LIST */}
                    <ul className="mb-8 space-y-2">
                      {project.details.map((d) => (
                        <li key={d} className="flex items-center gap-3 text-[13px] text-black/55">
                          <span className="w-1 h-1 rounded-full bg-black/25 flex-shrink-0" />
                          {d}
                        </li>
                      ))}
                    </ul>

                    <div className="flex items-center gap-4">
                      <Link
                        to={project.link}
                        className="inline-flex items-center gap-3 bg-black text-white text-[13px] font-medium px-5 py-3 rounded-full hover:opacity-75 transition-opacity"
                      >
                        Voir le projet
                        <span>→</span>
                      </Link>
                      <Link
                        to="/contact"
                        className="text-[13px] text-black/40 hover:text-black transition-colors"
                      >
                        Projet similaire ?
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </section>

        {/* FOOTER CTA */}
        <section className="pb-28">
          <div className="rounded-[28px] bg-black text-white px-8 md:px-12 py-12 md:py-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div>
              <p className="text-[11px] uppercase tracking-[0.18em] text-white/40 mb-4">
                Votre projet, le prochain ?
              </p>
              <h2 className="text-[2rem] md:text-[3rem] font-bold leading-[1] tracking-[-0.04em] max-w-md">
                Donnons vie à un projet à votre image
              </h2>
            </div>
            <Link
              to="/contact"
              className="self-start md:self-auto inline-flex items-center gap-3 bg-white text-black text-[13px] font-medium px-6 py-3.5 rounded-full hover:opacity-80 transition-opacity flex-shrink-0"
            >
              Nous contacter
              <span>→</span>
            </Link>
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
}